import React from 'react'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { SocialFeed } from '../../components/dashboard'

const SocialPosts: React.FC = () => {
  return (
    <div className="h-full flex flex-col overflow-x-hidden overflow-y-auto">
      <PermissionGuard moduleName="social_posts" permissionType="show">
        <div className="py-6 px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
              Postagens
            </Heading>
            <Text size="sm" color="muted" className="mt-2">
              Moderação do feed social.
            </Text>
          </div>
          <SocialFeed moderation />
        </div>
      </PermissionGuard>
    </div>
  )
}

export default SocialPosts
